import { Box, Skeleton, IconButton } from '@mui/material';
import { MdOutlineMoreVert } from 'react-icons/md';
import Grid from '@mui/material/Grid2';

export default function KnowledgeBasesSkeleton() {
  return (
    <>
      {/* Header Section Skeleton */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Skeleton variant='text' width={150} height={32} />
        <Box display='flex' gap={1}>
          <Skeleton variant='rectangular' width={200} height={40} sx={{ borderRadius: 1 }} />
          <Skeleton variant='rectangular' width={180} height={40} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>

      {/* Knowledge Base Cards Grid Skeleton */}
      <Grid container spacing={3} mt={3}>
        {[...Array(6)].map((_, index) => (
          <Grid
            key={index}
            size={{ xs: 12, md: 6, lg: 4 }}
            bgcolor='background.paper'
            border='1px solid #F3F3F3'
            borderRadius={0.5}
            padding={3}
          >
            {/* Card Header with Title and Menu */}
            <Box display='flex' justifyContent='space-between' alignItems='center'>
              <Skeleton variant='text' width={120} height={24} />
              <IconButton size='small'>
                <MdOutlineMoreVert />
              </IconButton>
            </Box>

            {/* Description Skeleton */}
            <Skeleton variant='text' width='100%' height={20} sx={{ my: 1 }} />
            <Skeleton variant='text' width='80%' height={20} sx={{ mb: 3 }} />

            {/* Docs Count Skeleton */}
            <Box display='flex' gap={1} alignItems='center'>
              <Skeleton variant='circular' width={16} height={16} />
              <Skeleton variant='text' width={60} height={20} />
            </Box>

            {/* Date Skeleton */}
            <Box display='flex' gap={1} alignItems='center' marginTop={1}>
              <Skeleton variant='circular' width={16} height={16} />
              <Skeleton variant='text' width={100} height={20} />
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
